import React from "react";
import { Stars } from "./icons";
import { Photo } from "./photo";

export const Testimonials = ({ data }) => (
  <section id="avis" className="section testimonials">
    <div className="container">
      <h2 className="section-title">Ils nous font confiance</h2>

      <div className="testimonials-grid">
        {(data || []).map((t) => (
          <article className="testimonial" key={t.name}>
            <Photo
              src={t.image}
              alt={t.name}
              label={t.name.charAt(0)}
              className="testimonial-avatar"
            />
            <div>
              <div className="testimonial-head">
                <strong>{t.name}</strong>
                <Stars rating={t.rating} />
              </div>
              <p>{t.text}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
